module.exports = __webpack_public_path__ + "img/type3.2fd2fd20.png";